import { DynamicPricesSettings, DynamicPricesSettingsForm } from '../types'

type DynamicEmsFlags = Pick<DynamicPricesSettings, 'isDynamicEmsEnabledForBattery' | 'isSgReadyEnabled'>

/**
 * Builds the full settings payload for a price limit change (e.g. from the dynamic power price widget).
 * All settings except the price limits are taken over unchanged. The AI360 and SG Ready flags are left undefined
 * ("unchanged") so the update resolves them from the actual EMS settings instead of the combined display value of
 * `useDynamicPricesSettings`, which also includes the feed-in tariff for AI360 2.0.
 */
export const mergePriceLimitsIntoSettings = (settings: DynamicPricesSettings | null, limits: DynamicPricesSettingsForm): DynamicPricesSettings => ({
  networkFees: settings?.networkFees ?? '0',
  energyPriceSurcharge: settings?.energyPriceSurcharge ?? '0',
  taxes: settings?.taxes ?? '0',
  dynamicPricesForWallboxesEnabled: settings?.dynamicPricesForWallboxesEnabled ?? false,
  priceLimitWallbox: limits.priceLimitWallbox ?? '0',
  dynamicPricesForBatteryEnabled: settings?.dynamicPricesForBatteryEnabled ?? false,
  priceLimitBattery: limits.priceLimitBattery ?? '0',
  activeMonthsBattery: settings?.activeMonthsBattery ?? [],
  referencePrice: settings?.referencePrice ?? '0',
  batteryStateOfChargeLimit: settings?.batteryStateOfChargeLimit ?? '0',
  isDynamicEmsEnabledForBattery: undefined,
  isSgReadyEnabled: undefined,
})

/**
 * Resolves the AI360 flags for a settings update. A missing (undefined) flag means "unchanged",
 * so callers that only update other settings cannot deactivate AI360 or SG Ready by accident.
 */
export const resolveDynamicEmsFlags = (newValues: DynamicEmsFlags, currentValues: DynamicEmsFlags | null): DynamicEmsFlags => ({
  isDynamicEmsEnabledForBattery: newValues.isDynamicEmsEnabledForBattery ?? currentValues?.isDynamicEmsEnabledForBattery,
  isSgReadyEnabled: newValues.isSgReadyEnabled ?? currentValues?.isSgReadyEnabled,
})
